<template>
  <div
    class="the-header has-text-weight-bold has-background-white is-hidden-print"
  >
    <header class="container p-t-md p-b-md is-hidden-touch">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="navbar-brand">
              <router-link class="navbar-item" :to="{ name: 'home' }">
                <img
                  src="@/assets/images/logo.png"
                  alt="Logo Casa Administraciones"
                />
              </router-link>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div v-show="showSearchbar" class="level-item is-relative">
            <b-input
              class="header-search"
              placeholder="Buscar por inmueble o zona en jalisco"
              icon="search"
              icon-clickable
              v-model="searchText"
              @click.native.stop="showDropdownSearch = true"
              @keypress.native.enter="handleSearch"
            >
            </b-input>
            <dropdown-search
              v-on-clickaway="handleClickAway"
              v-show="showDropdownSearch"
              class="dropdown-search"
              @search="handleSearch"
              @hide="showDropdownSearch = false"
            />
          </div>
        </transition>
        <div class="level-right">
          <div class="level-item">
            <span
              v-show="!showSearchbar"
              class="has-text-primary pointer"
              @click="handleSignIn"
            >
              <vue-fontawesome icon="user" class="m-r-sm" />
              Ingresar
            </span>
          </div>
          <div class="level-item">
            <button
              class="button is-primary has-text-weight-bold"
              @click="handleCalltoAction"
            >
              Quiero vender o rentar
            </button>
          </div>
        </div>
      </div>
    </header>
    <hr />
    <b-navbar wrapper-class="container" class="has-text-weight-bold">
      <template slot="brand">
        <b-navbar-item
          class="is-hidden-desktop"
          tag="router-link"
          :to="{ path: '/' }"
        >
          <img
            src="@/assets/images/logo.png"
            alt="Logo Casa Administraciones"
          />
        </b-navbar-item>
      </template>

      <template slot="start">
        <b-navbar-item
          tag="router-link"
          class="is-hidden-desktop"
          :to="{ name: 'admin' }"
        >
          Ingresar
        </b-navbar-item>
        <b-navbar-item tag="div" class="is-hidden-desktop">
          <button
            class="btn-rent button is-primary has-text-weight-bold"
            @click="handleCalltoAction"
          >
            Quiero vender o rentar
          </button>
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'rent-buy' }"
          :active="$route.name === 'rent-buy'"
        >
          Rentar / Comprar
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'manage-properties' }"
          :active="$route.name === 'manage-properties'"
        >
          Administrar Propiedades
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'experience' }"
          :active="$route.name === 'experience'"
        >
          Experiencia CA
        </b-navbar-item>
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'alliances' }"
          :active="$route.name === 'alliances'"
        >
          Alianzas CA
        </b-navbar-item>
      </template>

      <template slot="end">
        <b-navbar-item
          tag="router-link"
          :to="{ name: 'contact' }"
          :active="$route.name === 'contact'"
        >
          Contáctanos
        </b-navbar-item>
        <b-navbar-item
          href="https://medium.com/@blogCasaAdministraciones"
          target="_blank"
        >
          Blog
        </b-navbar-item>
        <b-navbar-item
          v-show="showSearchbar"
          tag="router-link"
          :to="{ name: 'admin' }"
          class="has-text-primary"
        >
          <vue-fontawesome icon="user" class="m-r-sm" />
          Ingresar
        </b-navbar-item>
      </template>
    </b-navbar>
    <hr />
  </div>
</template>

<script>
import DropdownSearch from "@/components/DropdownSearch";
import Routes from "@/constants/router/route-names";
import { directive as onClickaway } from "vue-clickaway";

export default {
  name: "TheHeader",

  components: {
    DropdownSearch
  },

  directives: {
    onClickaway
  },

  props: {
    showSearchbar: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      searchText: "",
      showDropdownSearch: false
    };
  },

  computed: {
    filterSearchText() {
      return this.$store.getters["filter/searchText"];
    }
  },

  watch: {
    filterSearchText(newVal) {
      this.searchText = newVal;
    }
  },

  methods: {
    handleCalltoAction() {
      this.$router.push({ name: Routes.MANAGE_PROPERTIES });
    },

    handleSignIn() {
      this.$router.push({ name: Routes.ADMIN });
    },

    handleSearch() {
      if (this.searchText != null) {
        this.$store.commit("filter/update_searchtext", this.searchText);
      }
      if (this.$route.query.type) {
        // console.log("Query type");
        // console.log(this.$route.query.type);
        this.$router
          .push({ name: "properties", query: { type: this.$route.query.type } })
          .catch(err => {});
      } else {
        this.$router.push({ name: "properties" }).catch(err => {});
      }
    },

    handleClickAway() {
      this.showDropdownSearch = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.the-header {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;
  width: 100%;
}

hr {
  margin: 0px;
  border: none;
  height: 1px;
}

.header-search {
  width: 450px;
}

.btn-rent {
  display: inline;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.dropdown-search {
  position: absolute;
  top: 36px;
  z-index: 100;
}

.pointer {
  cursor: pointer;
}

@media only screen and (min-width: 769px) {
  a.is-active {
    position: relative;

    &::before {
      content: "";
      position: absolute;
      bottom: 0px;
      left: 15%;
      width: 70%;
      height: 5px;
      background-color: $primary-green;
    }
  }
}

@media only screen and (min-width: 1024px) {
  .navbar-brand .navbar-item {
    padding-left: 0px !important;
  }
}
</style>
